import { render, staticRenderFns } from "./PersonExams.vue?vue&type=template&id=eca8793a"
import script from "./PersonExams.vue?vue&type=script&lang=js"
export * from "./PersonExams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports